import classNames from 'clsx';
import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NEW_PORTAL_HEADER } from 'reactApp/appHelpers/configHelpers';
import { galleryAnchorsRequest, galleryLoadCategoryRequest } from 'reactApp/modules/gallery/gallery.module';
import { getGalleryCategories, getGalleryCategory, getIsFastscrollEnabled } from 'reactApp/modules/gallery/gallery.selectors';
import { GalleryCategoryType } from 'reactApp/modules/gallery/gallery.types';
import { resetSelect } from 'reactApp/modules/selections/selections.actions';
import { BreadcrumbsContainer } from 'reactApp/ui/BreadcrumbsContainer/BreadcrumbsContainer';
import { PageTabMenu } from 'reactApp/ui/PageTabMenu/PageTabMenu';
import { sendGa } from 'reactApp/utils/ga';

import styles from './GalleryPage.css';

interface GalleryPageTabMenuProps {
    className?: string;
}

export const GalleryPageTabMenu = memo<GalleryPageTabMenuProps>(function GalleryPageTabMenu({ className }) {
    const dispatch = useDispatch();

    const currentCategory = useSelector(getGalleryCategory);
    const categories = useSelector(getGalleryCategories);

    const isFastScrollEnabled = useSelector(getIsFastscrollEnabled);

    const handleMenuTabClick = useCallback(
        (category) => {
            sendGa('clicktab', 'category');
            if (isFastScrollEnabled) {
                dispatch(galleryAnchorsRequest({ category: GalleryCategoryType[category] }));
            } else {
                dispatch(galleryLoadCategoryRequest({ category: GalleryCategoryType[category] }));
            }

            dispatch(resetSelect());
        },
        [dispatch, isFastScrollEnabled]
    );

    return (
        <div
            className={classNames(className, {
                [styles.headerContainer_new_portal_header]: NEW_PORTAL_HEADER,
            })}
        >
            <BreadcrumbsContainer />
            <div className={styles.menu}>
                <PageTabMenu current={currentCategory} tabs={categories} onClick={handleMenuTabClick} changeHash />
            </div>
        </div>
    );
});
